// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__18UkI","loaderOuter":"PageOverlayLoader_loaderOuter__37PG7"};